<template>
<div class="bash-wrap price-wrap" id="price" name="price":style="'background:url(' + indata.bgcImage + ') no-repeat 50% 50%;'">
            <div class="bash-box">
                <p class="price">{{ indata.FirstTitle }}</p>
              <div class="banner-btn-box">
                    <a class="go-next" target="_blank" :href="indata.btnUrl1">免费试用</a>
                    <a :href="indata.btnUrl2" target="_blank">实例演示</a>
                </div>
            </div>
        </div>
          
           
</template>
<style scoped src="../../public/css/erp.css">

</style>



<script>
export default {
  name: "Templates16",
  props: {
    indata: Array,
  },
  computed: {
  //这里设置banner 是在900像素下高度为200px，我的banner图格式为1920X900像素
    autoHeight() {
      let _w =
        document.documentElement.clientWidth || document.body.clientWidth;
      return (_w * 200) / 450 + "px";
    }
  },
  data() {
    return {
      NowIndex: 0,
    };
  },
  methods: {
    changeActive(index) {
      this.NowIndex = index;
    },
  },
};
</script>


